import { useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import { ROUTE_PATHS } from 'routes/route-paths';

export const useKnowledgeBaseNavigation = () => {
  const navigate = useNavigate();
  const navigateToKnowledgeBase = useCallback(() => {
    navigate(`/settings/${ROUTE_PATHS.KNOWLEDGE_BASE}`);
  }, [navigate]);
  const navigateToKnowledgeBaseFolder = useCallback(
    (folderId: number) => {
      navigate(
        `/settings/${ROUTE_PATHS.KNOWLEDGE_BASE}/${ROUTE_PATHS.KNOWLEDGE_BASE_FOLDER.replace(':folderId', String(folderId))}`,
      );
    },
    [navigate],
  );

  return { navigateToKnowledgeBase, navigateToKnowledgeBaseFolder };
};
